import api from '../../api/restaurant/restaurantKitchenOrderApi';
import {
  CustomResponse,
  RestaurantKitchenOrderDTO,
  RestaurantKitchenOrderFilters,
  RestaurantKitchenPrintJobDTO,
} from '../../types/restaurant/RestaurantKitchenOrderTypes';

const printJobsFrom = (value: unknown): RestaurantKitchenPrintJobDTO[] => {
  if (Array.isArray(value)) return value;
  if (
    value &&
    typeof value === 'object' &&
    Array.isArray((value as { data?: unknown }).data)
  ) {
    return (value as { data: RestaurantKitchenPrintJobDTO[] }).data;
  }
  return [];
};

const RestaurantKitchenOrderService = {
  list: async (branchId: number, filters: RestaurantKitchenOrderFilters) => {
    const query = new URLSearchParams();
    if (filters.stationId) query.set('stationId', String(filters.stationId));
    if (filters.status) query.set('status', filters.status);
    query.set('_ts', String(Date.now()));
    const suffix = query.size ? `?${query.toString()}` : '';
    const response = await api.fetchCustom(`/branches/${branchId}${suffix}`);
    const result = response.data as CustomResponse<RestaurantKitchenOrderDTO[]>;

    return {
      ...result,
      data: (result.data ?? []).filter(
        (order) =>
          order.orderStatus !== 'CLOSED' && order.orderStatus !== 'CANCELLED'
      ),
    };
  },
  get: async (id: number) =>
    (await api.fetchById(id)).data as CustomResponse<RestaurantKitchenOrderDTO>,
  start: async (id: number) =>
    (await api.addCustom(`/${id}/start`, {}))
      .data as CustomResponse<RestaurantKitchenOrderDTO>,
  markReady: async (id: number) =>
    (await api.addCustom(`/${id}/ready`, {}))
      .data as CustomResponse<RestaurantKitchenOrderDTO>,
  startItem: async (kitchenOrderId: number, itemId: number) =>
    (await api.addCustom(`/${kitchenOrderId}/items/${itemId}/start`, {}))
      .data as CustomResponse<RestaurantKitchenOrderDTO>,
  markItemReady: async (kitchenOrderId: number, itemId: number) =>
    (await api.addCustom(`/${kitchenOrderId}/items/${itemId}/ready`, {}))
      .data as CustomResponse<RestaurantKitchenOrderDTO>,
  printJobs: async (kitchenOrderId: number) =>
    printJobsFrom(
      (await api.fetchCustom(`/${kitchenOrderId}/print-jobs`)).data
    ),
  reprint: async (kitchenOrderId: number) =>
    printJobsFrom((await api.addCustom(`/${kitchenOrderId}/reprint`, {})).data),
};

export default RestaurantKitchenOrderService;
